export default {
  Titulo: 'Endereço',
  Campos: {
    Cep: {
      Tipo: 'mask',
      Label: 'CEP',
      Tooltip: 'CEP',
      Placeholder: 'CEP',
      Mascara: 'CEP',
      Obrigatorio: true,
    },
    UF: {
      Tipo: 'combobox',
      Label: 'UF',
      Tooltip: 'UF',
      Placeholder: 'UF',
      Obrigatorio: true,
      Desabilitado: true,
      itens: [
        { Texto: 'Acre', Valor: 'AC' },
        { Texto: 'Alagoas', Valor: 'AL' },
        { Texto: 'Amapá', Valor: 'AP' },
        { Texto: 'Amazonas', Valor: 'AM' },
        { Texto: 'Bahia', Valor: 'BA' },
        { Texto: 'Ceará', Valor: 'CE' },
        { Texto: 'Distrito Federal', Valor: 'DF' },
        { Texto: 'Espírito Santo', Valor: 'ES' },
        { Texto: 'Goiás', Valor: 'GO' },
        { Texto: 'Maranhão', Valor: 'MA' },
        { Texto: 'Mato Grosso', Valor: 'MT' },
        { Texto: 'Mato Grosso do Sul', Valor: 'MS' },
        { Texto: 'Minas Gerais', Valor: 'MG' },
        { Texto: 'Pará', Valor: 'PA' },
        { Texto: 'Paraíba', Valor: 'PB' },
        { Texto: 'Paraná', Valor: 'PR' },
        { Texto: 'Pernambuco', Valor: 'PE' },
        { Texto: 'Piauí', Valor: 'PI' },
        { Texto: 'Rio de Janeiro', Valor: 'RJ' },
        { Texto: 'Rio Grande do Norte', Valor: 'RN' },
        { Texto: 'Rio Grande do Sul', Valor: 'RS' },
        { Texto: 'Rondônia', Valor: 'RO' },
        { Texto: 'Roraima', Valor: 'RR' },
        { Texto: 'São Paulo', Valor: 'SP' },
        { Texto: 'Sergipe', Valor: 'SE' },
        { Texto: 'Santa Catarina', Valor: 'SC' },
        { Texto: 'Tocantins', Valor: 'TO' },
      ],
    },
    Cidade: {
      Tipo: 'suggestion',
      Label: 'Cidade',
      Tooltip: 'Cidade',
      Placeholder: 'Cidade',
      Obrigatorio: true,
      Desabilitado: true,
    },
    Tipo: {
      Tipo: 'suggestion',
      Label: 'Tipo',
      Placeholder: 'Tipo',
      Tooltip: 'Tipo',
      Obrigatorio: true,
      Desabilitado: true,
    },
    Logradouro: {
      Tipo: 'suggestion',
      Label: 'Logradouro',
      Tooltip: 'Logradouro',
      Placeholder: 'Logradouro',
      Obrigatorio: true,
      Desabilitado: true,
    },
    Bairro: {
      Tipo: 'suggestion',
      Label: 'Bairro',
      Tooltip: 'Bairro',
      Placeholder: 'Bairro',
      Obrigatorio: true,
      Desabilitado: true,
    },
    Numero: {
      Tipo: 'number',
      Label: 'Número',
      Tooltip: 'Número',
      Placeholder: 'Número',
      Tamanho: 9,
      Desabilitado: true,
      Obrigatorio: true,
    },
    Complemento: {
      Tipo: 'text',
      Label: 'Complemento',
      Tooltip: 'Complemento',
      Placeholder: 'Complemento',
      Tamanho: 60,
      Desabilitado: true,
    },
    ComplementoNumero: {
      Tipo: 'text',
      Label: 'Complemento Número',
      Tooltip: 'Complemento Número',
      Placeholder: 'Complemento Número',
      Tamanho: 10,
      Desabilitado: true,
    },
    Quadra: {
      Tipo: 'text',
      Label: 'Quadra',
      Tooltip: 'Quadra',
      Placeholder: 'Quadra',
      Tamanho: 10,
      Desabilitado: true,
      Obrigatorio: true,
    },
    Lote: {
      Tipo: 'text',
      Label: 'Lote',
      Tooltip: 'Lote',
      Placeholder: 'Lote',
      Tamanho: 10,
      Desabilitado: true,
      Obrigatorio: true,
    },
    TipoEndereco: {
      Tipo: 'radio',
      RemovePanel: true,
      Itens: [
        {
          Texto: 'Endereço no Brasil',
          Valor: 1,
          Tooltip: 'Endereço no Brasil',
          Tamanho: 5,
          Checked: true,
        },
        {
          Texto: 'Endereço no Exterior',
          Valor: 2,
          Tooltip: 'Endereço no Exterior',
          Tamanho: 6,
        },
      ],
    },
  },
};
